
import { computed, defineComponent, onBeforeUnmount, ref, watch } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "../store";
export default defineComponent({
  name: "BaseFeedHeader",
  props: {
    createRoute: {
      required: true,
      type: String,
    },
    needsToBeAdmin: {
      required: true,
      type: Boolean,
    },
  },
  setup(props, { emit }) {
    const router = useRouter();
    const store = useStore();
    const searchInput = ref("");
    watch(
      () => searchInput.value,
      () => {
        emit("inputChange", searchInput.value);
      }
    );

    const toCreate = () => {
      router.push(props.createRoute);
    };

    const windowWidth = ref(window.innerWidth);
    const onResize = () => {
      windowWidth.value = window.innerWidth;
    };
    window.addEventListener("resize", onResize);
    onBeforeUnmount(() => {
      window.removeEventListener("resize", onResize);
    });

    const isAdminAndAdminNeeded = computed(
      () => !store.getters.getUser.isAdmin && props.needsToBeAdmin
    );

    return {
      searchInput,
      toCreate,
      windowWidth,
      isAdminAndAdminNeeded,
    };
  },
});
